module.exports = __webpack_public_path__ + "img/educationIcon.31174d59.png";